import { css } from 'styled-components';

import colors from '../../utils/colors';

import { IconButtonType, StyledIconButtonProps } from './types';

const COLORS: Record<
  IconButtonType,
  {
    backgroundColor: string;
    borderColor: string;
    iconColor: string;
  }
> = {
  primary: {
    backgroundColor: 'gradient',
    borderColor: colors.transparent,
    iconColor: colors.white100,
  },
  secondary: {
    backgroundColor: colors.transparent,
    borderColor: colors.ink100,
    iconColor: colors.ink100,
  },
  white: {
    backgroundColor: colors.white100,
    borderColor: colors.transparent,
    iconColor: colors.ink100,
  },
  info: {
    backgroundColor: colors.transparent,
    borderColor: colors.ink100,
    iconColor: colors.ink100,
  },
  infolight: {
    backgroundColor: colors.transparent,
    borderColor: colors.ink50,
    iconColor: colors.ink50,
  },
  infodark: {
    backgroundColor: colors.transparent,
    borderColor: colors.ink100,
    iconColor: colors.ink100,
  },
  success: {
    backgroundColor: colors.transparent,
    borderColor: colors.success100,
    iconColor: colors.success100,
  },
  danger: {
    backgroundColor: colors.transparent,
    borderColor: colors.error100,
    iconColor: colors.error100,
  },
  transparent: {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    iconColor: colors.whiteAlpha50,
  },
};

const button = css<StyledIconButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  ${({ $size }) => `
    width: ${$size}px;
    height: ${$size}px;
    border-radius: ${$size / 2}px;
  `}
  border: ${({ $shouldHideBorderWidth, $borderColor }) =>
    `${$shouldHideBorderWidth ? '0' : '1px'} solid ${$borderColor}`};
`;

const disabled = `
  opacity: 0.5;
`;

export default {
  colors: COLORS,
  button,
  disabled,
};
